<div class="export-jobs-dropdown">
  <div
    class="download-jobs"
    [class.has-new-jobs]="hasNewDownloadJobs"
    [class.loading]="downloadJobsLoading"
    (click)="toggleDownloadJobsDropdown($event)"
  >
    <i class="pi pi-download download-jobs-icon" title="Exports" aria-label="Exports"></i>
    <i
      class="pi download-jobs-chevron"
      [ngClass]="showDownloadJobs ? 'pi-chevron-up' : 'pi-chevron-down'"
      title="Exports"
      aria-label="Exports"
    ></i>
  </div>

  <div *ngIf="showDownloadJobs" class="download-jobs-dropdown" (click)="$event.stopPropagation()">
    <div *ngIf="downloadJobsLoading" class="download-jobs-placeholder">Loading exports...</div>
    <div *ngIf="!downloadJobsLoading && !exportJobs.length" class="download-jobs-placeholder">No export jobs</div>
    <div *ngFor="let job of exportJobs" class="download-job-row">
      <a
        *ngIf="!isJobLinkDisabled(job); else disabledJobLink"
        [href]="job.download_url"
        target="_blank"
        rel="noopener noreferrer"
        >{{ formatExportJobDate(job) }}</a
      >
      <ng-template #disabledJobLink>
        <span class="disabled-job-link">{{ formatExportJobDate(job) }}</span>
      </ng-template>
    </div>
  </div>
</div>
